import React from 'react';
import {UModal} from "../../src";
import UButton from "../UButton";

const UNewSurveyPopup = React.memo((props) => {
    return (
        <React.Fragment>
            <UModal
                open={true}
                className={'u_sidebar-modal'}
                maxWidth={700}
                onClose={() => props?.close()}
                header={<h4>Added New Survey</h4>}
                footer={<></>}
            >
                <div className="u_p-20 u_view-survey">
                    <div className="u_view-survey-image">
                        <img src="https://files.superworks.com/custom/images/new-survey.svg" alt="A new survey has been added" />
                    </div>
                    <h4>A new survey has been added</h4>
                    <p>A new survey has been added, if you want to view the survey click on the button below</p>
                    <div className="u_view-survey-btn"><UButton variant="blue" type="View Survey" onClick={() => props?.redirect()} /></div>
                </div>
            </UModal>
        </React.Fragment>
    );
});

export default UNewSurveyPopup;
